import ENDPOINTTYPE from './EndpointService/EndpointType';
const _maxStateHistoryCount = typeof process.env.REACT_APP_GRAPH_HISTORY_TICKS !== undefined ? process.env.REACT_APP_GRAPH_HISTORY_TICKS : 50;

const endpoints = [
    // Alert endpoints
    {
        id: 'alertList_simple',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query: '{alerts$FILTERS$ {id, lastTimeSeen, triggerCounter, device_Id, device_Code}}',
        filters: ['organization', 'state'],
        lifetime: 1000,
    },
    {
        id: 'alertList_full',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query:
            '{alerts$FILTERS$ { id, code, type, state, source, severity, description, device_Id, device_Code, device {name, type, status, code}, firstTimeSeen, lastTimeSeen, triggerCounter}}',
        filters: ['organization', 'state'],
    },
    {
        id: 'alert_cancel',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v3/messages`, // Only the root url, parameters (accepted, defaulted and forced) are provided via filters
        method: 'POST',
        contentType: 'text/plain',
        doDoubleCall: true,
        filters: ['organization', 'fields_csv', { key: 'activityType', value: 'DeviceStatus_NOTRACK' }],
    },
    {
        id: 'alert_create',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v3/messages`, // Only the root url, parameters (accepted, defaulted and forced) are provided via filters
        method: 'POST',
        contentType: 'text/plain',
        doDoubleCall: true,
        filters: ['organization', 'fields_csv', { key: 'activityType', value: 'DeviceStatus_NOTRACK' }],
    },

    // Device Endpoints
    {
        id: 'deviceList_codes',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query: '{devices$FILTERS$ {code}}',
        filters: ['organization'],
    },
    {
        id: 'deviceList_default',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query:
            '{devices$FILTERS$ {id,code,name,status,isOnline,description,lifeCycleStatus,lastTimeSeenOnline,type,subType,alertCount{active all resolved}, upTime { start, end, onlineTime, result}, metadata { values(namesCsv: "coordinates_lat,coordinates_lon")}}}',
        filters: ['organization', 'notProvisioned'],
    },
    {
        id: 'deviceList_withactivealertsonly',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query:
            '{devices$FILTERS$ { id,code,name,status,isOnline,description,lastTimeSeenOnline,type,subType,lifeCycleStatus, upTime { start, end, onlineTime, result}, metadata { values(namesCsv: "coordinates_lat,coordinates_lon")}, alerts(state: ACTIVE) { code, state, source, severity, id, severity}}}',
        filters: ['organization'],
    },
    {
        id: 'device_details',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query: `{device$FILTERS$ {id,code,name,status,isOnline,description,lastTimeSeenOnline,lifeCycleStatus,type,subType,alertCount{active all resolved}, metadata {raw, values(namesCsv: "coordinates_lat,coordinates_lon")}, alternativeIds, upTime { start, end, onlineTime, result}, currentState{ raw }, stateHistory(limit:${_maxStateHistoryCount}){timestamp,values(namesCsv: "cpu_temperature,cpu_used,memory_used,fs_used,temperature.temperature")} , alerts { id, code, type, state, source, severity, description, device_Id, firstTimeSeen, lastTimeSeen, triggerCounter}, fatResults(allTime:true)}}`,
        filters: ['organization', 'code'],
        clearOnDone: true,
    },
    {
        id: 'device_details_forced',
        type: ENDPOINTTYPE.GRAPHQL_FORCED,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query: `{device$FILTERS$ {id,code,name,status,isOnline,description,lastTimeSeenOnline,type,alertCount{active all resolved}, metadata {raw, values(namesCsv: "coordinates_lat,coordinates_lon")}, alternativeIds, upTime { start, end, onlineTime, result}, currentState{ raw }, stateHistory(limit:${_maxStateHistoryCount}){timestamp,values(namesCsv: "cpu_temperature,cpu_used,memory_used,fs_used,temperature.temperature")} , alerts { id, code, type, state, source, severity, description, device_Id, firstTimeSeen, lastTimeSeen, triggerCounter}, fatResults}}`,
        filters: ['organization', 'code'],
        clearOnDone: true,
    },
    {
        id: 'device_metadata_update',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v3/Devices/$deviceCode$/metadata`,
        method: 'PUT',
        filters: [
            { key: 'array_merge_strategy', value: 'Replace', forced: true },
            { key: 'object_merge_strategy', value: 'Replace', forced: true },
        ],
        clearOnDone: true,
    },
    {
        id: 'device_update',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v3/Devices/$deviceCode$`,
        method: 'PUT',
        filters: [],
        clearOnDone: true,
    },
    {
        id: 'device_frequent_update',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query: '{devices$FILTERS$ {id,code,status,isOnline,lifeCycleStatus,lastTimeSeenOnline,alertCount{active all resolved}}}',
        filters: ['organization'],
        clearOnDone: true,
    },
    {
        id: 'device_inventory_list',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query: '{allDevices$FILTERS$ {code,name,organizationId,locationName, type, lifeCycleStatus, testStatus, testStatusUpdatedAt}}',
        filters: ['organization', 'retired'],
    },

    // These Device Command Socket endpoints are not implemented yet.
    // {
    //     id: "device_command_startvpn",
    //     type: ENDPOINTTYPE.WEBSOCKET,
    //     url: process.env.REACT_APP_SOCKETIO_SERVER_URL + "/device/$deviceCode$/command/start_vpn",
    // },
    // {
    //     id: "device_command_stopvpn",
    //     type: ENDPOINTTYPE.WEBSOCKET,
    //     url: process.env.REACT_APP_SOCKETIO_SERVER_URL + "/device/$deviceCode$/command/stop_vpn",
    // },

    {
        id: 'cabinet_command',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_CABINET_API_URL}/api/v1/command`,
        method: 'POST',
        filters: [],
        clearOnDone: true,
    },

    // User endpoints
    {
        id: 'user_info',
        type: ENDPOINTTYPE.REST_CACHED,
        url: `${process.env.REACT_APP_API_URL}/v4/me`,
        method: 'GET',
        filters: [],
    },

    // Passport endpoint
    {
        id: 'user_organization_update_passport',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_AUTH_URL}/api/internal/profile`,
        method: 'PUT',
        filter: [],
        clearOnDone: true,
    },

    // Organization Endpoints
    {
        id: 'organizations_list',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query: '{organizations$FILTERS$ {id, name, status, streetAddress, city, resellerId, country, metadata{raw}, clientSegment, type, parentId}}',
        filters: ['organization'],
    },
    {
        id: 'organization_new',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v4/Organizations`,
        method: 'POST',
        filter: [],
        clearOnDone: true,
    },
    {
        id: 'organization_update',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v4/Organizations/$organizationId$`,
        method: 'PUT',
        filter: [],
        clearOnDone: true,
    },
    {
        id: 'organization_delete',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v4/Organizations/$organizationId$`,
        method: 'DELETE',
        filter: [],
        clearOnDone: true,
    },
    {
        id: 'organization_metadata_update',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v4/Organizations/$organizationId$/metadata`,
        method: 'PUT',
        filter: [],
        clearOnDone: true,
    },

    //ALERT NOTIFICATION
    {
        id: 'get_alert_config',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query: '{organization$FILTERS$ {alertConfigurations{ alertTypes,id,isActive,receivers,userName,locationIds}}}',
        filters: ['id'],
    },

    {
        id: 'create_alert_config',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v4/Organizations/$organizationId$/notificationConfiguration`,
        method: 'POST',
        filters: [],
        clearOnDone: true,
    },
    {
        id: 'update_alert_config',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v4/Organizations/$organizationId$/notificationConfiguration/$configurationId$`,
        method: 'PUT',
        filters: [],
        clearOnDone: true,
    },
    {
        id: 'delete_alert_config',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v4/Organizations/$organizationId$/notificationConfiguration/$configurationId$`,
        method: 'DELETE',
        filters: [],
        clearOnDone: true,
    },

    // Locations Endpoint
    {
        id: 'locations_list',
        type: ENDPOINTTYPE.GRAPHQL,
        url: `${process.env.REACT_APP_API_URL}/v4/graphql`,
        query: '{locations$FILTERS${code, name, type, status, owners{id}, parentLocationCode }}',
        filters: ['organization', { key: 'includeChildren', value: 'FLAT', forced: true }, 'statuses'],
    },
    {
        id: 'location_new',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v4/locations`,
        method: 'POST',
        filter: [],
        clearOnDone: true,
    },
    {
        // Update and Delete is done using the same endpoint
        id: 'location_update',
        type: ENDPOINTTYPE.REST,
        url: `${process.env.REACT_APP_API_URL}/v4/locations/$locationId$`,
        method: 'PUT',
        filter: [],
        clearOnDone: true,
    },
];

const endpointServices = [
    {
        type: ENDPOINTTYPE.GRAPHQL,
        serviceId: 'GraphQLService',
        requestKey: 'query',
        cancelKey: 'abortQuery',
    },
    {
        type: ENDPOINTTYPE.GRAPHQL_FORCED,
        serviceId: 'GraphQLService',
        requestKey: 'forceQuery',
        cancelKey: 'abortQuery',
    },
    {
        type: ENDPOINTTYPE.REST,
        serviceId: 'FetchService',
        requestKey: 'request',
        sendKey: 'send',
        cancelKey: 'abortRequest',
    },
    {
        type: ENDPOINTTYPE.REST_CACHED,
        serviceId: 'FetchService',
        requestKey: 'cachedRequest',
        sendKey: 'send',
        cancelKey: 'abortRequest',
    }
];

export { endpoints, endpointServices };
